// Mock data for Hotny Mota Portfolio

export const personalInfo = {
  name: 'Hotny Mota',
  title: 'Analista Imobiliário',
  subtitle: 'Especialista em Regularização de Imóveis e Projetos de Engenharia',
  description: 'Profissional com vasta experiência em regularização de terrenos, averbações, projetos arquitetônicos e estruturais. Transformo sonhos em realidade com soluções completas para seu imóvel.',
  email: 'contato@hotnymota.com.br',
  phone: '(11) 99999-9999',
  whatsapp: '5511999999999',
  location: 'Rdenção, PA',
  instagram: 'https://www.instagram.com/hotnymota',
  yearsExperience: '10+',
  projectsCompleted: '500+'
};

export const services = [
  {
    id: 1,
    icon: 'FileCheck',
    title: 'Regularização de Terrenos',
    description: 'Documentação completa do seu terreno, do zero ao financiamento. Processo ágil e seguro para legalizar sua propriedade.'
  },
  {
    id: 2,
    icon: 'Home',
    title: 'Averbação de Construção',
    description: 'Registro de construções para financiamentos e valorização do seu imóvel. Processo completo e descomplicado.'
  },
  {
    id: 3,
    icon: 'Layers',
    title: 'Desdobro e Unificação',
    description: 'Divisão ou unificação de terrenos com toda assessoria técnica e documental necessária.'
  },
  {
    id: 4,
    icon: 'FileText',
    title: 'Escrituração de Terrenos',
    description: 'Elaboração e registro de escrituras públicas com segurança jurídica e agilidade.'
  },
  {
    id: 5,
    icon: 'PenTool',
    title: 'Projetos Arquitetônicos',
    description: 'Desenvolvimento de projetos arquitetônicos personalizados, funcionais e esteticamente planejados.'
  },
  {
    id: 6,
    icon: 'Ruler',
    title: 'Projetos Estruturais',
    description: 'Projetos estruturais seguros e eficientes, garantindo a solidez da sua construção.'
  }
];

export const projects = [
  {
    id: 1,
    title: 'Regularização Residencial',
    category: 'Regularização',
    description: 'Regularização completa de terreno residencial de 300m² em zona urbana.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80'
  },
  {
    id: 2,
    title: 'Projeto Arquitetônico Residencial',
    category: 'Projetos',
    description: 'Desenvolvimento de projeto arquitetônico moderno para residência de alto padrão.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
  },
  {
    id: 3,
    title: 'Desdobro de Lote Comercial',
    category: 'Desdobro',
    description: 'Divisão de terreno comercial de 1000m² em 4 lotes independentes.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80'
  },
  {
    id: 4,
    title: 'Averbação de Construção',
    category: 'Averbação',
    description: 'Averbação de construção de 250m² para liberação de financiamento.',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&q=80'
  },
  {
    id: 5,
    title: 'Projeto Estrutural Comercial',
    category: 'Projetos',
    description: 'Projeto estrutural para edifício comercial de 3 pavimentos.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80'
  },
  {
    id: 6,
    title: 'Regularização Rural',
    category: 'Regularização',
    description: 'Regularização de propriedade rural com área de 5 hectares.',
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Maria Silva',
    role: 'Proprietária',
    content: 'Excelente profissional! Regularizou meu terreno em tempo recorde. Recomendo muito o trabalho do Hotny.',
    rating: 5
  },
  {
    id: 2,
    name: 'João Santos',
    role: 'Empresário',
    content: 'Fez o desdobro do meu lote comercial com muita eficiência. Processo transparente e bem conduzido.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana Paula Costa',
    role: 'Investidora',
    content: 'Profissional sério e competente. Conseguiu a averbação da minha construção rapidamente.',
    rating: 5
  }
];